import { KTIcon } from "../../../../../_metronic/helpers";

const UserEditModalHeader = ({
  setSelectedListingId,
  openAdditionalUserModal,
  setOpenAdditionalUserModal,
  listing,
  selectedUser,
  setSelectedUser
}) => {
  return (
    <div className="modal-header">
      {/* begin::Modal title */}
      <div>
      <h2 className="fw-bolder listing_title">{`${selectedUser ? `Edit ${selectedUser.name} User` : 'Add Additional User'} for ${listing.title}` }</h2>
      {/* <h6>You can add up to 3 users that will receive notifications</h6> */}
      </div>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary"
        data-kt-users-modal-action="close"
        onClick={() => {
          setSelectedListingId()
          setOpenAdditionalUserModal(false)
          setSelectedUser()
        }}
        style={{ cursor: "pointer" }}
      >
        <KTIcon iconName="cross" className="fs-1" />
      </div>
      {/* end::Close */}
    </div>
  );
};

export { UserEditModalHeader };
